import { SyncOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React from 'react';
import './assets/ButtonStyle.css';

export const ResetButton = ({ onClick, loading }) => {
  return (
    <Tooltip title={loading ? 'Loading...' : 'Reload'}>
      <span className='resetButton' onClick={onClick}>
        <SyncOutlined spin={loading} style={{ fontSize:'16.5px'}} />
      </span>
    </Tooltip>
  );
};
